module.exports = __webpack_public_path__ + "skill.jun.png";